import api from 'utils/api'
import serverErrorMessage from 'utils/server-errors'

const state = {
  user: null,
  userToken: window.localStorage.getItem('user_token'),
  authError: null
}

const getters = {
  isAuthenticated: (state) => {
    return !!state.userToken;
  }
}

const actions = {
  login: (store, auth) => {
    return api.post('/auth', { auth })
      .then(({ jwt }) => {
        window.localStorage.setItem('user_token', jwt)
        store.commit('setToken', jwt)
      })
      .catch(err => {
        store.commit('setError', 'Unable to log in with these credentials.')
        return Promise.reject(err);
      })
  },

  logout: (store) => {
    window.localStorage.removeItem('user_token')
    window.localStorage.removeItem('account_access_token')
    store.commit('setToken', null)
    store.commit('AUTH_TOKEN', null)
  },

  fetchRegistration: (store, token) => {
    const params = { token };
    return api.get('/registration', { params })
      .then(({ user }) => {
        store.commit('setUser', user)
      })
      .catch(err => {
        store.commit('setError', 'No user found, invalid token.')
        return Promise.reject(err);
      })
  },

  register: (store, { token, user }) => {
    return api.post('/registration', { token, user })
      .then(({ jwt }) => {
        window.localStorage.setItem('user_token', jwt)
        store.commit('setToken', jwt)
      })
      .catch(err => {
        store.commit('setError', serverErrorMessage(err, 'An error occured, registration not complete.'))
        return Promise.reject(err);
      })
  },

  createPasswordReset: (store, email) => {
    return api.post('/password_reset', { email })
      .then(r => {

      })
      .catch(err => {
        store.commit('setError', 'No user found with that email address.')
        return Promise.reject(err);
      })
  },

  fetchPasswordReset: (store, token) => {
    const params = { token };
    return api.get('/password_reset', { params })
      .then(({ user }) => {
        store.commit('setUser', user)
      })
      .catch(err => {
        store.commit('setError', 'No user found, invalid token.')
        return Promise.reject(err);
      })
  },

  resetPassword: (store, { token, user }) => {
    return api.patch('/password_reset', { token, user })
      .then(({ jwt }) => {
        window.localStorage.setItem('user_token', jwt)
        store.commit('setToken', jwt)
      })
      .catch(err => {
        store.commit('setError', serverErrorMessage(err, 'An error occured, password not reset.'))
        return Promise.reject(err);
      })
  }

}

const mutations = {
  setToken: (state, token) => {
    state.userToken = token;
  },

  setUser: (state, user) => {
    state.user = user;
  },

  setError: (state, error) => {
    state.authError = error;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
